module.exports = __webpack_public_path__ + "img/logo-sfic-et-vous.0ae0b278.jpg";